<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da página -->
          <basic-toolbar :title="'Editar Instituição'"></basic-toolbar>

          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

              <!-- Nome -->
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    label='Nome'
                    :value="instituicaoProjetoPesquisa.nome === null || instituicaoProjetoPesquisa.nome === '' ? '-' : instituicaoProjetoPesquisa.nome"
                    readonly
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <!-- Sigla -->
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    label='Sigla'
                    :value="instituicaoProjetoPesquisa.sigla === null || instituicaoProjetoPesquisa.sigla === '' ? '-' : instituicaoProjetoPesquisa.sigla"
                    readonly
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <!-- Tipo -->
              <v-layout row>
                <v-flex xs12>
                  <v-select
                    label='Tipo*'
                    :items="listaTipoInstituicaoProjetoPesquisa"
                    v-model="instituicaoProjetoPesquisa.tipoInstituicao"
                    item-text="descricao"
                    item-value="item"
                    max-height="400"
                    return-object
                    required
                    autocomplete
                    :rules="obrigatorio" >
                  </v-select>
                </v-flex>
              </v-layout>

              <br>

              </v-container>
            </v-form>

            <v-divider></v-divider>

            <v-card-actions>

              <!-- Botão "Cancelar" -->
              <v-btn color="primary" @click="cancelar()">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Botão "Salvar" -->
              <v-btn color="primary" :disabled="!formularioValido" @click="editaInstituicaoProjetoPesquisa()">Salvar</v-btn>

            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import projetos from '@/utils/projetos'
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjetoPesquisa', 'idInstituicaoProjetoPesquisa'],
    data: () => ({
      formularioValido: false,
      instituicaoProjetoPesquisa: {},
      listaTipoInstituicaoProjetoPesquisa: [],
      obrigatorio: [v => !!v || 'Este campo é obrigatório']
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Edita a instituição do projeto de pesquisa.
      editaInstituicaoProjetoPesquisa: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando instituição do projeto de pesquisa...' })
        projetos.putInstituicaoProjetoPesquisa(this.idProjetoPesquisa, this.idInstituicaoProjetoPesquisa, this.instituicaoProjetoPesquisa)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ProjetoPesquisaInstituicoes'})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando instituição do projeto de pesquisa...' })
        })
      },

      // Carrega uma tabela estruturada.
      opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        })
      },

      // Redireciona para a página anterior.
      cancelar: function () {
        this.$router.go(-1)
      }
    },
    mounted () {
      // Carrega a instituição do projeto de pesquisa.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando instituição do projeto de pesquisa...' })
      projetos.getInstituicaoProjetoPesquisa(this.idProjetoPesquisa, this.idInstituicaoProjetoPesquisa)
      .then(response => {
        this.instituicaoProjetoPesquisa = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando instituição do projeto de pesquisa...' })
      })

      // Carrega lista com os tipos de instituição de um projeto de pesquisa (Tabela estruturada - código 1165).
      this.opcoesTabelaEstruturada(1165, this, 'listaTipoInstituicaoProjetoPesquisa')
    },
    components: {
      'basic-toolbar': BasicToolbar
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// editar-instituicao.vue?df56999a